import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import animationData from "../assets/magic-loader.json";
import "./AIMagicLoader.css";

const AIMagicLoader = ({ isDone, extractedCount, onClose }) => {
  const [fadeOut, setFadeOut] = useState(false);

  // When extraction is done → wait 1.2s → fade out → remove component
  useEffect(() => {
    if (isDone) {
      setTimeout(() => {
        setFadeOut(true);
      }, 1200);

      // Remove entirely after fade
      setTimeout(() => {
        if (onClose) onClose();
      }, 2000);
    }
  }, [isDone, onClose]);

  return (
    <div className={`ai-loader-overlay ${fadeOut ? "fade-out" : ""}`}>
      <div className="ai-loader-center">
        <Lottie
          animationData={animationData}
          loop={!isDone}
          renderer="svg"
          style={{ width: 350, height: 350 }}
        />

        {!isDone ? (
          <p className="ai-loader-text">Extracting information from your documents…</p>
        ) : (
          <p className="ai-loader-text-done">
            ✓ Extracted {extractedCount} fields successfully!
          </p>
        )}
      </div>
    </div>
  );
};

export default AIMagicLoader;